// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_2cVXY","separator":"index_separator_1n0ZG"};